import { lighten, Theme, useTheme } from '@mui/material';
import {
  ThemeColor,
  useBackgroundColor,
  UseBackgroundColorType,
} from '@stack/theme';

import { CustomAvatarType } from './props';

/**
 * function to get actual styles for avatar
 */
export const getAvatarStyles = (options: {
  theme: Theme;
  skin?: CustomAvatarType;
  color: ThemeColor;
  background: UseBackgroundColorType;
}) => {
  const { skin, background, color, theme } = options;
  let avatarStyles;

  if (skin === 'light') {
    avatarStyles = { ...background[`${color}Light`] };
  } else if (skin === 'light-static') {
    avatarStyles = {
      color: background[`${color}Light`].color,
      backgroundColor: lighten(theme.palette[color].main, 0.88),
    };
  } else {
    avatarStyles = { ...background[`${color}Filled`] };
  }

  return avatarStyles;
};

/**
 * hooks to get avatar variant styles
 */
export const useAvatarVariantStyles = (skin?: CustomAvatarType) => {
  const theme = useTheme();
  const background: UseBackgroundColorType = useBackgroundColor();

  const options = {
    theme,
    skin,
    background,
  };

  const colors: UseBackgroundColorType = {
    primary: getAvatarStyles({ ...options, color: 'primary' }),
    secondary: getAvatarStyles({ ...options, color: 'secondary' }),
    success: getAvatarStyles({ ...options, color: 'success' }),
    error: getAvatarStyles({ ...options, color: 'error' }),
    warning: getAvatarStyles({ ...options, color: 'warning' }),
    info: getAvatarStyles({ ...options, color: 'info' }),
  };

  return colors;
};
